<template>
  <!-- <pre v-if="responseData">responseData={{ kecil[1] }}</pre> -->
  <AdminBackground v-if="responseData1 && responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/PROJEK BP.1.png"
        alt="PROJEK BP.1"
        class="pbt-image"
      >

      <div class="line-under-image" />
    </div>


    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      
      <h2>RINGKASAN PERUNTUKAN DAN BELANJA</h2>

      
      
      <div class="content-wrapper">
        <h4>PROJEK SKALA KECIL</h4>
        <div>
          <PieChart :chart-data="ProjekSkalaKecil" />
          <Update />
        </div>
      </div>

      <div class="content-wrapper">
        <h4>PROJEK SKALA BESAR</h4>
        <div>
          <PieChart :chart-data="ProjekSkalaBesar" />
          <Update />
        </div>
      </div>

      <h2>STATUS PELAKSANAAN PROJEK BP.1</h2>
      <div class="pbtpay-status">
        <VTable
          height="450"
          class="text-no-wrap"
        >
          <thead>
            <tr>
              <th>NEGERI</th>
              <th>PBT</th>
              <th>BELUM IKLAN</th>
              <th>TELAH IKLAN</th>
              <th>TELAH MULA DITAPAK</th>
              <th>PROJEK SIAP</th>
              <th>JUMLAH</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(statusBp1, index) in statusBp1s"
              :key="index"
            >
              <td>{{ statusBp1.state }}</td>
              <td>{{ statusBp1.council }}</td>
              <td>{{ statusBp1.belumIklan }}</td>
              <td>{{ statusBp1.telahIklan }}</td>
              <td>{{ statusBp1.dalamPelaksanaan }}</td>
              <td>{{ statusBp1.siap }}</td>
              <td>{{ statusBp1.jumlah }}</td>
            </tr>
          </tbody>
        </VTable>
      </div>
      <Update />
    </div>
  </AdminBackground>

  <PrimaryModule />
  <PembangunanMenu />
</template>



<script setup>
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'



const years = ref([])
const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref(2024)
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')

const ProjekSkalaKecil=ref([])
const ProjekSkalaBesar=ref([])

const statusBp1s = ref([])
const data = ref([])
const data1  = ref()




//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})


const { httpGet, numberWithCommas } = useHttpService()

const responseData = ref(null)
const responseData1 = ref(null)
const kecil = ref()


const displayNameMapping = {
  // eslint-disable-next-line camelcase
  peruntukan_semasa: "Peruntukan Semasa",
  perbelanjaan: "Perbelanjaan",
  // eslint-disable-next-line camelcase
  // perbelanjaan_peratus: "Peratus",
}


function filterSpecificData(data1) {
  const categoriesToDisplay = ['peruntukan_semasa', 'perbelanjaan']
  
  return Object.entries(data1)
    .filter(([name]) => categoriesToDisplay.includes(name))
    .map(([name, value]) => ({ name: displayNameMapping[name], value }))
}

async function loadDataFromApi(year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {

    // Ensure we're working with a plain array for states
    const plainStates = toRaw(state)

    // Create query parameters for year and states
    // Create the query parameters manually
    let queryParams = `year=${year}`
    console.log('Plain states:', plainStates)

    // Check if states are "Semua Negeri" and skip appending states[] if true
    if (!plainStates.includes("Semua Negeri")) {
      // Append each state to the query string with the desired 'states[]' format
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }


    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
    
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }


    // const url1 = `pembangunan/ringkasan-projek-bp1?${queryParams}`
    // const response1 = await httpGet(url1) 

const url1 = `https://jktgateway.kpkt.gov.my/api/pembangunan/ringkasan-projek-bp1?${queryParams}`

const res = await fetch(url1)
const response1 = await res.json()


    responseData1.value = response1
    data1.value = response1.data

    kecil.value = response1.data 
    ProjekSkalaKecil.value = filterSpecificData(kecil.value[0])
    ProjekSkalaBesar.value = filterSpecificData(kecil.value[1])

  

    // const url2 = `pembangunan/status-pelaksanaan-projek-bp1?${queryParams}`

    // const response2 = await httpGet(url2)

    const url2 = `https://jktgateway.kpkt.gov.my/api/pembangunan/ringkasan-projek-bp1?${queryParams}`

const res2 = await fetch(url2)
const response2 = await res2.json()


    years.value = response2.years


   states.value = ["Semua Negeri"];

if (response2 && Array.isArray(response2.states)) {
  response2.states.forEach(state => {
    if (state && state !== "Modified Pbt") {
      states.value.push(state);
    }
  });
} else {
  console.error("Invalid response2 or states:", response2);
}


    councils.value = response2.councils
    responseData.value = response2
    data.value = response2.data.data

    statusBp1s.value = []
    for (let i in data.value) {
      statusBp1s.value.push({
        state: data.value[i].state,
        council: data.value[i].council,
        belumIklan: data.value[i].belum_iklan,
        telahIklan: data.value[i].telah_iklan,
        dalamPelaksanaan: data.value[i].dalam_pelaksanaan,
        siap: data.value[i].siap,
        jumlah: data.value[i].jumlah,
      })
    }


  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

function handleStateChange() {
  pbt.value = []

  // Ensure selectedsState and selectedPbt are arrays
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : []
  }

  // Remove "Semua Negeri" if other states are selected
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }

  // Remove "Semua PBT" if other PBTs are selected
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter(pbt => pbt !== "Semua PBT")
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }

  // If no PBTs are selected, reset to "Semua PBT"
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"]
  }

  if (selectedsState.value.includes("Semua Negeri")) {

    Object.keys(councils.value).forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  } else {

    selectedsState.value.forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  }

  console.log('Filtered PBT:', pbt.value)
}


onMounted(() => {
  loadDataFromApi()
  
})

//this is for setting the inital values for pbts as semua negeri id default option for Negeri (state) 
watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })


watch([selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>


<style scoped>
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}


.input-item {
  flex: 1;
  margin-right: 15px;
}


.input-item:last-child {
  margin-right: 0;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); 
  border-radius: 20px; 
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; /* Match width to the image size */
  margin-block-start: 10px;
}

/* Add styles for the new Saring button */
.filter-btn {
  border: none;
  border-radius: 5px;
  background-color: #13017f;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 10%);
  color: white;
  cursor: pointer;
  font-size: 1rem;
  margin-inline-start: 40px; /* Spacing between date picker and button */
  padding-block: 10px;
  padding-inline: 20px;
}

.filter-btn:hover {
  background-color: #001f73; /* Darker shade on hover */
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: start;
}

h3 {
  position: relative;
  display: flex;
  align-items: center;
  color: #000;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  inline-size: 160px;
  margin-block-start: 10px;
  text-align: start;
}

h4 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: center;
}

.filter-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  inline-size: 100%;
  margin-block-end: 20px;
}

.content {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  inline-size: 100%;
}

/* Image Grid */
.image-grid {
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(7, 1fr);
  inline-size: 100%;
  max-inline-size: 1600px;
}

.text-overlay {
  position: absolute;
  border-end-end-radius: 10px;
  border-end-start-radius: 10px;
  inline-size: 100%;
  inset-block-end: 0;
  padding-block: 20px;
  padding-inline: 0;
  text-align: center;
}

.name {
  color: white;
  font-size: 10px;
  font-weight: 600;
  margin-block-end: 25px;
}

.image-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  inline-size: 110%;
  padding-block-start: 90%;
}

.image-container img {
  position: absolute;
  block-size: 100%;
  border-start-end-radius: 10px;
  border-start-start-radius: 10px;
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  object-fit: cover;
}

/* New styles for the number and location in each state */
.number {
  color: #a80000;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
}

/* Table */
.pbtpay-status {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  inline-size: 100%;
  margin-block-end: 50px;
  max-inline-size: 1200px;
}

th {
  background-color: #fff;
  color: #150069 !important;
  font-size: 0.7rem;
  font-weight: bold;
}

td {
  background-color: #fff;
  color: #333;
  font-size: 0.7rem;
}

/* General table styles */
table {
  border-collapse: collapse;
  inline-size: 100%;
}

th,
td {
  padding: 15px;
  border: 1px solid #ddd;
  text-align: start;
}

/* Responsive styles */
@media (max-width: 768px) {
  .input-row {
    flex-direction: column;
    gap: 15px;
  }

  h2, h4 {
    font-size: 1.3rem;
  }

  .content-wrapper {
    padding: 15px;
  }

  th, td {
    font-size: 0.6rem;
    padding: 10px;
  }
}

@media (max-width: 480px) {
  h2, h4 {
    font-size: 1.2rem;
  }

  th, td {
    font-size: 0.5rem;
    padding: 8px;
  }

  .content-wrapper {
    padding: 10px;
  }
}
</style>
